export const Screens = {
    desktop: {
        min: 1024,
    },
    tablet: {
        max: 1040,
        min: 780,
    },
    smartphone: {
        max: 779,
    },
};
